import { CampaignType } from "./Campaign";

export interface IAsset {
    id?: number,
    dateCreated?: string,
    dateLastChanged?: string,
    dateDeleted?: string,
    deleted?: boolean,
    originalFileName: string,
    fileName: string,
    type: AssetType,
    campaignId: number,
    kbOriginalFileSize?: number,
    kbFileSize?: number
}

export class Asset implements IAsset {
    id: number;
    dateCreated: string;
    dateLastChanged: string;
    dateDeleted: string;
    deleted: boolean;
    originalFileName: string;
    fileName: string;
    type: AssetType;
    campaignId: number;
    kbOriginalFileSize: number;
    kbFileSize: number;

    constructor();
    constructor(obj: IAsset);
    constructor(obj?: IAsset) {
        this.originalFileName = obj && obj.originalFileName || undefined;
        this.fileName = obj && obj.fileName || undefined;
        this.type = obj && obj.type || undefined;
        this.campaignId = obj && obj.campaignId || undefined;
    }
}

export enum AssetType {
    desktopImage = 1,
    mobileImage = 2,
    video = 3,
    banner = 4
}

export class SimpleAsset {
    id: number;
    type: AssetType;
    filename: string;
    minified_filename: string;
    largestKbFileSize: number;
}

export class VideoBuildModel {
    env: string;
    creativeCode: string;
    campaignType: CampaignType;
    assets: SimpleAsset[];
}

export const enum VideoFileFormat {
    mp4 = 'mp4',
    webm = 'webm'
}
